<ng-container *ngIf="items.length === 0; else serviceList">
  <div class="no-appoint-message">
    <div>No Data Found!</div>
  </div>
</ng-container>

<ng-template #serviceList>
  <ng-container *ngFor="let item of items">
    <div class="service-container" *ngIf="item!.filters!.list()!.length > 0">
      <app-label [text]="item.title"> </app-label>
      <ul>
        <ng-container *ngFor="let filter of item.filters.list()">
          <li [ngClass]="filter.active ? 'active' : ''">
            {{ filter.item }}
          </li>
          <div *ngIf="filter.cost || filter.timespan" class="reports-container">
            <div *ngIf="filter.cost">
              <app-icon [item]="rupeeIcon"></app-icon>
              {{ filter.cost! }}
            </div>
            <div *ngIf="filter.timespan">
              <app-icon [item]="timerIcon"></app-icon>
              {{ filter.timespan! }}
            </div>
            <br />
          </div>
        </ng-container>
      </ul>
    </div>
  </ng-container>
</ng-template>

<app-loading-dimmer [active]="loading"></app-loading-dimmer>
